import React, {useCallback, useReducer, useState} from "react";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import {StoreReconciliationSheetResponse} from "./StoreReconciliationSheetResponse";
import {PrintStoreReconciliationSheetReducer} from "./reducers/PrintStoreReconciliationSheetReducer";


const initialState = {
    stationList: [],
    isLoading: false,
    isSuccess: false,
    searchStation: "",
    targetStation: ""
};

/* Shows autocomplete station code chooser and
*  inflates result
* */
export const PrintStoreReconciliationSheetDialog = ({isModalOpen, onModelOpenChange, checkedDrivers}) => {
    const [{ isLoading, isSuccess, targetStation}] = useReducer(PrintStoreReconciliationSheetReducer, initialState);
    const closeModal = useCallback(() => onModelOpenChange(false), []);
    const [isCASProcessOngoing, setCASProcessOngoing] = useState(false);

    return (
        <Modal
            title={"Print Store Reconciliation Sheet"}
            open={isModalOpen}
            onClose={closeModal}
            scrollContainer="viewport"
            closeLabel="Close"
            width={500}>
            <Box height={100}>
                {!isLoading && !isSuccess &&
                <Box>
                    <Text type="h100">Click Confirm to print Store Reconciliation Sheet</Text>
                    <br/>
                </Box>

                }
                {!isLoading && !isSuccess && !isCASProcessOngoing &&
                <ModalFooter>
                    <Row spacingInset="small" alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="small" onClick={closeModal}>
                            Cancel
                        </Button>
                        <Button type="primary" size="small" onClick={() => setCASProcessOngoing(true)}>
                            Confirm
                        </Button>
                    </Row>
                </ModalFooter>
                }
                {isCASProcessOngoing && closeModal()}

                {!isLoading && isSuccess &&
                <Row alignmentHorizontal="center" alignmentVertical="center" height="100%">
                    <Loader type="circular"/>
                    <Text type="h200">Store Reconciliation Sheet Generated Successfully.</Text>
                </Row>
                }
                {isCASProcessOngoing &&
                <StoreReconciliationSheetResponse checkedDrivers={checkedDrivers}  targetStation={targetStation}/>}
            </Box>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/PrintStoreReconciliationSheetDialog.js